// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Skeleton } from '@mui/material';
import {
  Heading,
  OptionsSelector,
  SectionContainer,
} from '@shared/ui-kit/components';
import { useModeledPortfolios } from '../hooks/use-modeled-portfolios';
import { MarketplaceItem } from './marketplace-item';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

export const ModeledPortfolios = () => {
  const { filters, data, isLoading, error } = useModeledPortfolios();

  return (
    <div className="pt-12">
      <div className="grid grid-cols-4 gap-6 ">
        {filters.map(item => (
          <div key={item.key}>
            <Heading variant="h5" className="pb-2 capitalize" title={item.label} />
            <OptionsSelector
              optionsAvailable={item.options}
              onChangeValueSelected={item.onChange}
              defaultText={item.placeholder}
              selectType="gray"
              optionSelected={item.selected}
              dataTestId="marketplace-filter"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
            />
          </div>
        ))}
      </div>

      {isLoading && (
        <div className="3xl:grid-cols-3 grid grid-cols-1 gap-6 xl:grid-cols-2">
          <Skeleton
            variant="rectangular"
            width="100%"
            height={400}
            className="mt-9"
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={400}
            className="mt-9"
          />
        </div>
      )}

      {error && (
        <SectionContainer
          className="mt-9 text-center text-base font-semibold text-primary-medium"
          testId="marketplace-fetch-error"
        >
          <Translation i18nKey="research.marketplace-fetch-error" ns="research" />
        </SectionContainer>
      )}

      {data.length === 0 && !isLoading && !error && (
        <SectionContainer
          className="mt-9 text-center text-base font-semibold text-primary-medium"
          testId="marketplace-search-error"
        >
          <Translation i18nKey="research.marketplace-search-error" ns="research" />
        </SectionContainer>
      )}

      <div className="3xl:grid-cols-3 mt-9 grid grid-cols-1 gap-6 xl:grid-cols-2 ">
        {data.map(item => (
          <MarketplaceItem key={item.portfolio_id} portfolio={item} />
        ))}
      </div>
    </div>
  );
};
